export const LangCode = {
  ja: 'ja-JP',
  en: 'en-US',
} as const;

export type LangCode = typeof LangCode[keyof typeof LangCode];
